/* Vlastní YMM – výběr kol podle auta / velikosti + garáž v prohlížeči */
(() => {
  const cfg = window.wuYmm || {};
  const assetUrl = (name) => (cfg.assetBase || '').replace('wu-ymm-znacky.json', name);
  const sizeCollection = cfg.sizeCollection || '/collections/alu-kola';
  const SIZE_KEYS = { roztec: 'custom.roztec', prumer: 'custom.prumer', sirka: 'custom._sirka' };
  const SIZE_ORDER = ['roztec', 'prumer', 'sirka'];
  const cache = {};
  const T = cfg.t || {};
  const tr = (k, d) => T[k] || d; /* texty z locales (layout/theme.liquid), česky jako záloha */

  const parseJSON = (t) => {
    try { return JSON.parse(t); } catch (e) {
      // náhled šablony / editor může k odpovědi přidat HTML – vezmi jen JSON
      const i = t.search(/[{[]/), j = Math.max(t.lastIndexOf('}'), t.lastIndexOf(']'));
      return JSON.parse(t.slice(i, j + 1));
    }
  };
  const getJSON = (url) => cache[url] || (cache[url] = fetch(url, { credentials: 'same-origin' })
    .then((r) => { if (!r.ok) throw new Error(url + ' ' + r.status); return r.text(); })
    .then(parseJSON)
    .catch((e) => { delete cache[url]; console.warn('[wu-ymm]', e); throw e; }));
  const store = {
    get(k, d) { try { return JSON.parse(localStorage.getItem(k)) ?? d; } catch (e) { return d; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  };
  const numSort = (a, b) => String(a).localeCompare(String(b), 'cs', { numeric: true });

  function fill(select, placeholder, items) {
    select.innerHTML = '';
    select.add(new Option(placeholder, ''));
    items.forEach(([label, value]) => select.add(new Option(label, value)));
    select.disabled = items.length === 0;
  }

  /* ---------- Vyhledávací select (combobox) – psaním se položky vyfiltrují ----------
     Původní <select> zůstává skrytý a dál nese hodnotu i logiku; pole jen vybírá jeho option. */
  const norm = (t) => String(t).normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  let comboId = 0;
  /* dotykové zařízení: ťuknutí neotevře klávesnici, hledá se v poli nahoře v seznamu */
  const isTouch = window.matchMedia && matchMedia('(hover: none) and (pointer: coarse)').matches;
  function enhanceSelect(select, light) {
    const step = select.closest('.wu-ymm-step');
    const input = document.createElement('input');
    const list = document.createElement('ul');
    const id = 'wu-ymm-combo-' + (++comboId);
    input.type = 'text';
    input.className = 'wu-ymm-combo__input';
    input.autocomplete = 'off';
    input.spellcheck = false;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-autocomplete', 'list');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-controls', id);
    input.setAttribute('aria-label', select.getAttribute('aria-label') || '');
    list.id = id;
    list.className = 'wu-ymm-combo__list' + (light ? ' wu-ymm-combo__list--light' : '');
    list.setAttribute('role', 'listbox');
    list.hidden = true;
    let search = null, searchLi = null;
    if (isTouch) {
      input.readOnly = true;
      input.setAttribute('inputmode', 'none');
      searchLi = document.createElement('li');
      searchLi.className = 'wu-ymm-combo__search';
      searchLi.setAttribute('role', 'presentation');
      search = document.createElement('input');
      search.type = 'search';
      search.autocomplete = 'off';
      search.spellcheck = false;
      search.enterKeyHint = 'search';
      search.placeholder = tr('search', 'Hledat…');
      search.setAttribute('aria-label', search.placeholder);
      searchLi.append(search);
      list.append(searchLi);
    }
    list.addEventListener('mousedown', (e) => { if (e.target !== search) e.preventDefault(); }); /* posuvník seznamu nesmí zavřít pole */
    select.before(input); /* input jako první prvek v <label>, aby klik na label fokusoval jeho */
    select.classList.add('wu-ymm-combo__native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    step.classList.add('wu-ymm-step--combo');

    let items = [];
    let active = -1;
    const options = () => [...select.options].filter((o) => o.value);
    function sync() {
      const o = select.selectedOptions[0];
      input.placeholder = select.options[0] ? select.options[0].text : '';
      input.value = o && o.value ? o.text : '';
      input.disabled = select.disabled;
      if (select.disabled) close();
    }
    function place() {
      const r = step.getBoundingClientRect();
      const below = window.innerHeight - r.bottom - 12;
      const above = r.top - 12;
      const up = below < 220 && above > below;
      list.style.left = r.left + 'px';
      list.style.width = r.width + 'px';
      list.style.maxHeight = Math.max(140, Math.min(320, up ? above : below)) + 'px';
      list.style.top = up ? '' : (r.bottom + 6) + 'px';
      list.style.bottom = up ? (window.innerHeight - r.top + 6) + 'px' : '';
    }
    function render(query) {
      const q = norm(query).split(/\s+/).filter(Boolean);
      items = options().filter((o) => { const t = norm(o.text); return q.every((w) => t.includes(w)); });
      [...list.children].forEach((li) => { if (li !== searchLi) li.remove(); });
      if (!items.length) {
        const li = document.createElement('li');
        li.className = 'wu-ymm-combo__empty';
        li.textContent = tr('noResults', 'Nic nenalezeno');
        list.append(li);
      }
      items.forEach((o, i) => {
        const li = document.createElement('li');
        li.className = 'wu-ymm-combo__opt';
        li.id = id + '-' + i;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', o.value === select.value);
        li.textContent = o.text;
        li.addEventListener('mousedown', (e) => { e.preventDefault(); pick(o); });
        list.append(li);
      });
      setActive(items.findIndex((o) => o.value === select.value && select.value !== ''));
    }
    function setActive(i) {
      const lis = list.querySelectorAll('.wu-ymm-combo__opt');
      if (active >= 0 && lis[active]) lis[active].classList.remove('is-active');
      active = i;
      if (i >= 0 && lis[i]) {
        lis[i].classList.add('is-active');
        lis[i].scrollIntoView({ block: 'nearest' });
        input.setAttribute('aria-activedescendant', lis[i].id);
      } else input.removeAttribute('aria-activedescendant');
    }
    function open() {
      if (select.disabled) return;
      (select.closest('dialog') || document.body).append(list);
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      step.classList.add('is-open');
      place();
      if (search) search.value = '';
      render('');
    }
    function close() {
      if (list.hidden) return;
      if (search && document.activeElement === search) search.blur();
      list.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      step.classList.remove('is-open');
    }
    function pick(o) {
      close();
      if (select.value !== o.value) {
        select.value = o.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      sync();
    }

    const field = () => search || input;
    input.addEventListener('focus', () => { if (!isTouch) input.select(); open(); });
    input.addEventListener('click', () => { if (list.hidden) { if (!isTouch) input.select(); open(); } });
    input.addEventListener('input', () => { if (list.hidden) open(); render(input.value); });
    input.addEventListener('blur', (e) => { if (search && e.relatedTarget === search) return; close(); sync(); });
    if (search) {
      search.addEventListener('input', () => render(search.value));
      search.addEventListener('blur', (e) => { if (e.relatedTarget === input) return; close(); sync(); });
    }
    const onKey = (e) => {
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (list.hidden) { open(); return; }
        const n = items.length;
        if (n) setActive(e.key === 'ArrowDown' ? (active + 1) % n : (active <= 0 ? n - 1 : active - 1));
      } else if (e.key === 'Enter') {
        e.preventDefault();
        const o = items[active >= 0 ? active : 0];
        if (!list.hidden && o && (active >= 0 || field().value)) pick(o);
      } else if (e.key === 'Escape' && !list.hidden) {
        e.preventDefault();
        e.stopPropagation(); /* nezavírat celý pop-up */
        close();
        sync();
      }
    };
    input.addEventListener('keydown', onKey);
    if (search) search.addEventListener('keydown', onKey);
    select.addEventListener('change', sync);
    new MutationObserver(sync).observe(select, { childList: true, attributes: true, attributeFilter: ['disabled'] });
    const reposition = () => { if (!list.hidden) place(); };
    window.addEventListener('resize', reposition);
    window.addEventListener('scroll', reposition, true);
    sync();
  }

  /* ---------- Garáž ---------- */
  const garage = {
    list: () => store.get('wu_vehicles', []),
    active: () => store.get('wu_vehicle', null),
    add(car) {
      const list = garage.list().filter((c) => c.url !== car.url);
      list.unshift(car);
      store.set('wu_vehicles', list.slice(0, 10));
      store.set('wu_vehicle', car);
      garage.render();
    },
    remove(url) {
      store.set('wu_vehicles', garage.list().filter((c) => c.url !== url));
      if ((garage.active() || {}).url === url) store.set('wu_vehicle', null);
      garage.render();
    },
    render() {
      const active = garage.active();
      /* v menu jen značka: „Auto: Audi“ (starší uložená auta nemají znacka → první slovo názvu) */
      document.querySelectorAll('[data-wu-ymm-label]').forEach((el) => {
        if (!active) { el.textContent = tr('pickCar', 'Vyberte auto'); return; }
        const pre = document.createElement('span');
        pre.className = 'wu-ymm-open__pre';
        pre.textContent = tr('carPrefix', 'Auto:') + ' ';
        const brand = document.createElement('span');
        brand.className = 'wu-ymm-open__brand';
        brand.textContent = active.znacka || active.name.split(' ')[0];
        el.replaceChildren(pre, brand);
      });
      const ul = document.querySelector('[data-wu-garage-list]');
      const add = document.querySelector('[data-wu-add]');
      if (!ul) return;
      const list = garage.list();
      ul.hidden = list.length === 0;
      if (add && list.length === 0) add.classList.add('is-open');
      ul.innerHTML = '';
      list.forEach((car) => {
        const li = document.createElement('li');
        li.className = 'wu-ymm__car' + (active && active.url === car.url ? ' is-active' : '');
        const pick = document.createElement('button');
        pick.type = 'button';
        pick.className = 'wu-ymm__pick';
        pick.innerHTML = '<span class="wu-ymm__radio" aria-hidden="true"></span>';
        pick.append(document.createTextNode(car.name));
        pick.addEventListener('click', () => { store.set('wu_vehicle', car); garage.render(); });
        const del = document.createElement('button');
        del.type = 'button';
        del.className = 'wu-ymm__del';
        del.setAttribute('aria-label', tr('removeCar', 'Odebrat auto'));
        del.innerHTML = '<svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 4h10M6 4V2.5h4V4M4.5 4l.6 9.5h5.8l.6-9.5" stroke="currentColor" stroke-width="1.3" fill="none"/></svg>';
        del.addEventListener('click', () => garage.remove(car.url));
        li.append(pick, del);
        ul.append(li);
      });
    }
  };

  /* ---------- Formulář ---------- */
  function initForm(form) {
    const tabs = form.querySelectorAll('[data-wu-tab]');
    const panels = form.querySelectorAll('[data-wu-panel]');
    let sizeLoaded = false;

    function showTab(name) {
      tabs.forEach((t) => t.classList.toggle('is-active', t.dataset.wuTab === name));
      tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.wuTab === name));
      panels.forEach((p) => { p.hidden = p.dataset.wuPanel !== name; });
      if (name === 'velikost' && !sizeLoaded && form.wuLoadSizes) { sizeLoaded = true; form.wuLoadSizes(0); }
    }
    tabs.forEach((t) => t.addEventListener('click', () => showTab(t.dataset.wuTab)));

    /* Podle auta (formulář jen s VIN – snippet wu-vin-glass – ho nemá) */
    if (form.querySelector('[data-wu-car="znacka"]')) {
      /* Podle auta: Značka › Model › Motor → kolekce motorizace.
         S polem Rok (snippet wu-ymm-finder): Rok › Značka › Model → kolekce generace (assets/wu-ymm-pcd.json),
         model bez kolekce generace ukáže 4. krok Motorizace. */
      const car = {
        rok: form.querySelector('[data-wu-car="rok"]'),
        znacka: form.querySelector('[data-wu-car="znacka"]'),
        model: form.querySelector('[data-wu-car="model"]'),
        motor: form.querySelector('[data-wu-car="motor"]')
      };
      const byYear = !!car.rok;
      if (!byYear) delete car.rok;
      const motorStep = form.querySelector('[data-wu-motor-step]');
      const goCar = form.querySelector('[data-wu-go="auto"]');
      const light = form.classList.contains('wu-ymm-form--modal');
      Object.values(car).forEach((s) => enhanceSelect(s, light));
      let brandData = {};
      let genUrl = '';
      const yearOf = (m) => { const r = String(m).match(/\[(\d{4})-(\d{4})\]/); return r ? [+r[1], +r[2]] : null; };
      const showMotor = (on) => {
        if (!motorStep) return;
        motorStep.hidden = !on;
        form.classList.toggle('wu-ymm-form--motor', on);
      };
      const loadBrands = () => getJSON(assetUrl('wu-ymm-znacky.json')).then((brands) => {
        if (!byYear) return fill(car.znacka, tr('brand', 'Značka'), brands);
        const y = +car.rok.value;
        if (!y) return fill(car.znacka, tr('brand', 'Značka'), []);
        return getJSON(assetUrl('wu-ymm-roky.json')).then((years) => {
          fill(car.znacka, tr('brand', 'Značka'), brands.filter(([, slug]) => (years[slug] || []).some(([a, b]) => y >= a && y <= b)));
        });
      });
      const resetFrom = (key) => {
        const order = ['znacka', 'model', 'motor'];
        const ph = { znacka: tr('brand', 'Značka'), model: tr('model', 'Model'), motor: tr('engine', 'Motorizace') };
        order.slice(order.indexOf(key)).forEach((k) => fill(car[k], ph[k], []));
        genUrl = '';
        showMotor(false);
        goCar.disabled = true;
      };

      if (byYear) {
        getJSON(assetUrl('wu-ymm-roky.json')).then((years) => {
          const all = Object.values(years).flat();
          const max = Math.min(Math.max(...all.map((r) => r[1])), new Date().getFullYear() + 1);
          const min = Math.min(...all.map((r) => r[0]));
          const list = [];
          for (let y = max; y >= min; y--) list.push([String(y), String(y)]);
          fill(car.rok, tr('year', 'Rok'), list);
        });
        car.rok.addEventListener('change', () => { resetFrom('znacka'); loadBrands(); });
      } else loadBrands();

      car.znacka.addEventListener('change', () => {
        resetFrom('model');
        if (!car.znacka.value) return;
        getJSON(assetUrl('wu-ymm-' + car.znacka.value + '.json')).then((data) => {
          brandData = data;
          const y = byYear ? +car.rok.value : 0;
          const models = Object.keys(data).filter((m) => { const r = y && yearOf(m); return !r || (y >= r[0] && y <= r[1]); });
          fill(car.model, tr('model', 'Model'), models.sort(numSort).map((m) => [m, m]));
        });
      });
      car.model.addEventListener('change', () => {
        resetFrom('motor');
        if (!car.model.value) return;
        const motors = (brandData[car.model.value] || []).map(([m, h]) => [m, h]);
        if (!byYear) { fill(car.motor, tr('engine', 'Motorizace'), motors); return; }
        const model = car.model.value;
        getJSON(assetUrl('wu-ymm-pcd.json')).catch(() => ({})).then((pcd) => {
          if (car.model.value !== model) return;
          const row = (pcd[car.znacka.value] || []).find((r) => r[0] === model);
          if (row && row[2]) { genUrl = '/collections/' + row[2]; goCar.disabled = false; }
          else if (motors.length === 1) { genUrl = '/collections/' + motors[0][1]; goCar.disabled = false; }
          else { fill(car.motor, tr('engine', 'Motorizace'), motors); showMotor(true); }
          form.dispatchEvent(new Event('change'));
        });
      });
      car.motor.addEventListener('change', () => { goCar.disabled = !car.motor.value; });
      form.wuPickedCar = () => {
        const url = car.motor.value ? '/collections/' + car.motor.value : genUrl;
        if (!url) return null;
        const znacka = car.znacka.selectedOptions[0].text;
        const parts = [znacka, car.model.value];
        if (car.motor.value) parts.push(car.motor.selectedOptions[0].text);
        return { znacka, name: parts.join(' '), url };
      };
      goCar.addEventListener('click', () => {
        const picked = form.wuPickedCar();
        if (!picked) return;
        garage.add(picked);
        window.location.href = picked.url;
      });

    }

    if (form.querySelector('[data-wu-go="velikost"]')) {
      /* Podle velikosti: Rozteč › Průměr › Šířka → Alu kola s filtry */
      const size = {};
      SIZE_ORDER.forEach((k) => { size[k] = form.querySelector('[data-wu-size="' + k + '"]'); });
      const goSize = form.querySelector('[data-wu-go="velikost"]');
      const placeholders = { roztec: tr('roztec', 'Rozteč'), prumer: tr('prumer', 'Průměr'), sirka: tr('sirka', 'Šířka') };

      function chosenParams(uptoIndex) {
        const params = new URLSearchParams();
        SIZE_ORDER.slice(0, uptoIndex).forEach((k) => {
          if (size[k].value) params.append('filter.p.m.' + SIZE_KEYS[k], size[k].value);
        });
        return params;
      }

      /* Statický strom velikostí (assets/wu-ymm-velikosti.json): { roztec: { prumer: [sirka, …] } } */
      function loadSizes(fromIndex) {
        SIZE_ORDER.slice(fromIndex).forEach((k) => fill(size[k], placeholders[k], []));
        getJSON(assetUrl('wu-ymm-velikosti.json')).then((tree) => {
          let node = tree;
          for (let i = 0; i < fromIndex; i++) node = node[size[SIZE_ORDER[i]].value];
          const values = Array.isArray(node) ? node : Object.keys(node || {});
          fill(size[SIZE_ORDER[fromIndex]], placeholders[SIZE_ORDER[fromIndex]], values.sort(numSort).map((v) => [v, v]));
        }).catch(() => { if (fromIndex === 0) sizeLoaded = false; });
      }
      form.wuLoadSizes = loadSizes;

      SIZE_ORDER.forEach((k, i) => {
        size[k].addEventListener('change', () => {
          goSize.disabled = !size.sirka.value;
          if (i < SIZE_ORDER.length - 1) loadSizes(i + 1);
        });
      });
      /* Kolekce rozteč + průměr (assets/wu-ymm-kolekce.json): { roztec: { prumer: handle } }.
         Velká kolekce alu-kola nejde spolehlivě filtrovat, proto se jde do menší (s filtry všech tří hodnot). */
      goSize.addEventListener('click', () => {
        const go = (map) => {
          const handle = map && (map[size.roztec.value] || {})[size.prumer.value];
          const params = chosenParams(SIZE_ORDER.length); // i v menší kolekci, aby byly filtry zaškrtnuté
          window.location.href = (handle ? '/collections/' + handle : sizeCollection) + '?' + params.toString();
        };
        getJSON(assetUrl('wu-ymm-kolekce.json')).then(go, () => go(null));
      });

    }

    /* Podle VIN: Worker vrátí rozměry kol z Registru vozidel → odkaz na kola s filtrem průměr + šířka */
    const vinPanel = form.querySelector('[data-wu-panel="vin"]');
    if (vinPanel) {
      const vinInput = vinPanel.querySelector('[data-wu-vin]');
      const vinOut = vinPanel.querySelector('[data-wu-vin-out]');
      const vinBtn = vinPanel.querySelector('[data-wu-go="vin"]');
      const vt = vinPanel.dataset;
      const el = (tag, cls, text) => { const n = document.createElement(tag); if (cls) n.className = cls; if (text != null) n.textContent = text; return n; };
      const say = (text, err) => {
        vinOut.textContent = '';
        vinOut.classList.toggle('is-error', !!err);
        if (text) vinOut.appendChild(el('p', 'wu-ymm-vin__msg', text));
        vinOut.hidden = !text;
      };
      const dec = (v) => String(v).replace('.', ',');
      /* Rozteč podle kolekcí aut (assets/wu-ymm-pcd.json: { znacka: [[„Model Gen [rok-rok]“, [rozteče], handle generace]] }).
         Registr rozteč neuvádí → značka + první slova modelu + rok registrace. Nenalezeno = rozteč se nezobrazí. */
      const norm = (t) => String(t || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
      const words = (t) => norm(t).split(/[^a-z0-9]+/).filter(Boolean);
      function findCar(d) {
        return getJSON(assetUrl('wu-ymm-znacky.json')).then((brands) => {
          const reg = norm(d.znacka).replace(/[^a-z0-9]/g, '');
          let brand = null;
          brands.forEach(([n, slug]) => {
            const b = norm(n).replace(/[^a-z0-9]/g, '');
            if (b && reg.startsWith(b) && (!brand || b.length > brand.len)) brand = { slug, len: b.length };
          });
          if (!brand) return null;
          return getJSON(assetUrl('wu-ymm-pcd.json')).then((all) => {
            const list = all[brand.slug] || [];
            const rw = words(d.model);
            if (!rw.length) return null;
            let best = 0, cands = [];
            list.forEach((row) => {
              const kw = words(row[0].split('[')[0]);
              let n = 0;
              while (n < 3 && kw[n] && rw[n] === kw[n]) n++;
              if (!n && /^\d$/.test(kw[0] || '') && new RegExp('^' + kw[0] + '\\d{2}').test(rw[0])) n = 1; // BMW 330d → řada 3
              if (!n) return;
              if (n > best) { best = n; cands = []; }
              if (n === best) cands.push(row);
            });
            const rok = parseInt(d.rok, 10);
            const inYear = cands.filter((row) => {
              const m = row[0].match(/\[(\d{4})-(\d{4})\]/);
              return m && rok >= +m[1] && rok <= +m[2];
            });
            const pick = inYear.length ? inYear : cands;
            const pcd = [...new Set(pick.flatMap((row) => row[1]))];
            if (!pcd.length || pcd.length > 2) return null;
            const car = { pcd, url: pick.length === 1 && pick[0][2] ? '/collections/' + pick[0][2] : '', gen: pick.length === 1 ? pick[0][0] : '', map: null };
            // menší kolekce rozteč + průměr jako u záložky Podle velikosti
            return getJSON(assetUrl('wu-ymm-kolekce.json')).then((map) => { car.map = map; return car; }, () => car);
          });
        }).catch(() => null);
      }
      function renderVin(d, car) {
        // stejné ráfky na víc nápravách sloučit („Přední i zadní“)
        const rims = new Map();
        (d.napravy || []).forEach((a) => {
          const pneu = a.pneu || [];
          (a.rafky || []).forEach((r, i) => {
            if (!r.prumer || !r.sirka) return;
            const key = r.sirka + 'x' + r.prumer + '|' + (r.et || '') + '|' + (pneu[i] || '');
            if (!rims.has(key)) rims.set(key, { r, pneu: pneu[i] || '', axles: [], load: 0 });
            const rim = rims.get(key);
            if (!rim.axles.includes(a.naprava)) rim.axles.push(a.naprava);
            rim.load = Math.max(rim.load, a.nosnost_kola || 0); // potřebná nosnost 1 kola (zatížení nápravy / 2)
          });
        });
        if (!rims.size) { say(vt.tNone, true); return; }
        vinOut.textContent = '';
        vinOut.classList.remove('is-error');
        const name = [d.znacka, d.model].filter(Boolean).join(' ') + (d.rok ? ' (' + d.rok + ')' : '');
        if (name.trim()) vinOut.appendChild(el('p', 'wu-ymm-vin__car', name));
        if (car) {
          const info = el('p', 'wu-ymm-vin__pcd', (vt.tPcd || 'Rozteč') + ' ' + car.pcd.join(' / '));
          if (vt.carLink === 'true' && car.url) {
            info.appendChild(document.createTextNode('  ·  '));
            const ca = el('a', 'wu-ymm-vin__carlink', car.gen);
            ca.href = car.url;
            info.appendChild(ca);
          }
          vinOut.appendChild(info);
        }
        const ul = el('ul', 'wu-ymm-vin__list');
        rims.forEach(({ r, pneu, axles, load }) => {
          const li = el('li', 'wu-ymm-vin__item');
          const label = axles.length > 1 ? vt.tBoth : (axles[0] === 1 ? vt.tFront : axles[0] === 2 ? vt.tRear : axles[0] + '.');
          li.appendChild(el('span', 'wu-ymm-vin__axle', label));
          li.appendChild(el('span', 'wu-ymm-vin__size', dec(r.sirka) + 'J × ' + r.prumer + '"' + (r.et ? '  ET' + r.et : '') + (pneu ? '  ·  ' + pneu : '')));
          if (load) li.appendChild(el('span', 'wu-ymm-vin__load', vt.tLoad + ' ' + load + ' kg'));
          const params = new URLSearchParams();
          if (car) car.pcd.forEach((p) => params.append('filter.p.m.' + SIZE_KEYS.roztec, p));
          params.append('filter.p.m.' + SIZE_KEYS.prumer, r.prumer + '"');
          params.append('filter.p.m.' + SIZE_KEYS.sirka, r.sirka + '"');
          const a = el('a', 'wu-ymm-vin__find', vt.tFind + ' ' + r.prumer + '" × ' + dec(r.sirka) + '"');
          const small = car && car.map && car.pcd.length === 1 && (car.map[car.pcd[0]] || {})[r.prumer + '"'];
          a.href = (small ? '/collections/' + small : sizeCollection) + '?' + params.toString();
          li.appendChild(a);
          ul.appendChild(li);
        });
        vinOut.appendChild(ul);
        vinOut.hidden = false;
      }
      vinPanel.addEventListener('submit', (e) => {
        e.preventDefault();
        const vin = vinInput.value.toUpperCase().replace(/\s+/g, '');
        vinInput.value = vin;
        if (!/^[A-HJ-NPR-Z0-9]{17}$/.test(vin)) { say(vt.tInvalid, true); vinInput.focus(); return; }
        say(vt.tLoading);
        vinBtn.disabled = true;
        fetch(vt.url.replace(/\/$/, '') + '/?vin=' + encodeURIComponent(vin))
          .then((r) => r.json().then((j) => ({ ok: r.ok, j })))
          .then(({ ok, j }) => {
            if (ok) return findCar(j).then((car) => renderVin(j, car));
            else say(j && j.error === 'invalid_vin' ? vt.tInvalid : j && j.error === 'not_found' ? vt.tNotFound : vt.tError, true);
          })
          .catch(() => say(vt.tError, true))
          .finally(() => { vinBtn.disabled = false; });
      });
      vinInput.addEventListener('input', () => {
        vinInput.closest('.wu-ymm-step').classList.toggle('is-done', vinInput.value.replace(/\s+/g, '').length === 17);
      });
    }

    /* Zvýraznění aktuálního kroku (modrý obrys) */
    function markCurrent() {
      form.querySelectorAll('[data-wu-panel]').forEach((panel) => {
        const sels = [...panel.querySelectorAll('select')].filter((s) => !s.closest('.wu-ymm-step').hidden);
        const cur = sels.find((s) => !s.value) || null;
        sels.forEach((s) => s.closest('.wu-ymm-step').classList.toggle('is-current', s === cur && !s.disabled));
        sels.forEach((s) => s.closest('.wu-ymm-step').classList.toggle('is-done', !!s.value));
      });
    }
    form.addEventListener('change', markCurrent);
    new MutationObserver(markCurrent).observe(form, { subtree: true, attributes: true, attributeFilter: ['disabled'] });

    const startTab = form.dataset.tab;
    showTab(startTab === 'velikost' || (startTab === 'vin' && vinPanel) ? startTab : 'auto');
    markCurrent();
  }

  /* ---------- Pop-up ---------- */
  function openModal() {
    const modal = document.querySelector('[data-wu-ymm]');
    if (!modal) return;
    const drawer = document.querySelector('menu-drawer');
    if (drawer && typeof drawer.close === 'function') drawer.close();
    garage.render();
    syncModalButtons();
    if (typeof modal.showModal === 'function') modal.showModal(); else modal.setAttribute('open', '');
    requestAnimationFrame(() => modal.classList.add('is-open'));
    document.documentElement.classList.add('wu-ymm-lock');
  }
  function closeModal() {
    const modal = document.querySelector('[data-wu-ymm]');
    if (!modal || !modal.open) return;
    modal.classList.remove('is-open');
    document.documentElement.classList.remove('wu-ymm-lock');
    setTimeout(() => { if (typeof modal.close === 'function') modal.close(); else modal.removeAttribute('open'); }, 250);
  }

  function modalPicked() {
    const f = document.querySelector('[data-wu-ymm] [data-wu-ymm-form]');
    const car = f && f.wuPickedCar ? f.wuPickedCar() : null;
    if (car) garage.add(car);
    return car;
  }

  /* Tlačítka v pop-upu jsou aktivní až po výběru všech tří hodnot ;
     „Zobrazit kola“ i pro vybrané uložené auto, když je formulář sbalený */
  function syncModalButtons() {
    const modal = document.querySelector('[data-wu-ymm]');
    if (!modal) return;
    const f = modal.querySelector('[data-wu-ymm-form]');
    const picked = !!(f && f.wuPickedCar && f.wuPickedCar());
    const add = modal.querySelector('[data-wu-add]');
    const addOpen = !!(add && add.classList.contains('is-open'));
    const view = modal.querySelector('[data-wu-view]');
    const save = modal.querySelector('[data-wu-save]');
    if (view) view.disabled = !(picked || (!addOpen && garage.active()));
    if (save) save.disabled = !picked;
  }

  function init() {
    document.querySelectorAll('[data-wu-ymm-form]').forEach(initForm);
    garage.render();
    syncModalButtons();
    const modalEl = document.querySelector('[data-wu-ymm]');
    if (modalEl) {
      modalEl.addEventListener('change', () => setTimeout(syncModalButtons));
      modalEl.addEventListener('click', () => setTimeout(syncModalButtons));
    }
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-wu-add-toggle]')) { e.target.closest('[data-wu-add]').classList.toggle('is-open'); return; }
      if (e.target.closest('[data-wu-view]')) {
        const car = modalPicked() || garage.active();
        if (car) window.location.href = car.url;
        else document.querySelector('[data-wu-add]').classList.add('is-open');
        return;
      }
      if (e.target.closest('[data-wu-save]')) { modalPicked(); closeModal(); return; }
      if (e.target.closest('[data-wu-ymm-open]')) { e.preventDefault(); openModal(); }
      else if (e.target.closest('[data-wu-close]')) closeModal();
    });
    const dlg = document.querySelector('[data-wu-ymm]');
    if (dlg) dlg.addEventListener('cancel', (e) => { e.preventDefault(); closeModal(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
